import {
  getRequiredAccessContexts,
  getUserFacingAccessSummary
} from "./detailUtils";

function formatRequirement(requirement) {
  const labels = {
    "Institution assignment": "Institution access required.",
    "Project context": "Project context required.",
    "Program context": "Program context required.",
    "Cohort context": "Cohort context required.",
    "Session context": "Session context required.",
    "Session code": "Session code required."
  };

  return labels[requirement] || requirement;
}

export default function CatalogEntryUserAccessPanel({ entry }) {
  const summary = getUserFacingAccessSummary(entry);
  const requiredAccessContexts = getRequiredAccessContexts(
    entry?.accessRequirements
  );

  const hasContent = Boolean(
    summary || requiredAccessContexts.length
  );

  if (!hasContent) {
    return null;
  }

  return (
    <section className="catalog-detail__panel">
      <h2>Access</h2>

      {summary ? <p>{summary}</p> : null}

      {requiredAccessContexts.length > 0 ? (
        <ul className="catalog-detail__bullet-list">
          {requiredAccessContexts.map((requirement) => (
            <li key={requirement}>
              {formatRequirement(requirement)}
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
